import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ClearIcon from '@material-ui/icons/Clear';
import Chip from '@material-ui/core/Chip';
import Select from 'react-select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

class Option extends React.Component {
  handleClick = event => {
    this.props.onSelect(this.props.option, event);
  };

  render() {
    const { children, isFocused, isSelected, onFocus } = this.props;

    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        onClick={this.handleClick}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
        }}
      >
        {children}
      </MenuItem>
    );
  }
}

function SelectWrapped(props) {
  const { classes, ...other } = props;
  return (

    <Select
      optionComponent={Option}
      noResultsText={<Typography>{'No results found'}</Typography>}
      arrowRenderer={arrowProps => {
        return arrowProps.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
      }}
      clearRenderer={() => <ClearIcon />}
      valueComponent={valueProps => {
        const { value, children, onRemove } = valueProps;

        const onDelete = event => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(value);
        };

        if (onRemove) {
          return (
            <Chip
              tabIndex={-1}
              label={children}
              className={classes.chip}
              deleteIcon={<CancelIcon onTouchEnd={onDelete} />}
              onDelete={onDelete}
            />
          );
        }

        return <div className="Select-value">{children}</div>;
      }}
      {...other}
    />
  );
}


const ITEM_HEIGHT = 48;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  // We had to use a lot of global selectors in order to style react-select.
  // We are waiting on https://github.com/JedWatson/react-select/issues/1679
  // to provide a much better implementation.
  // Also, we had to reset the default style injected by the library.
  '@global': {
    '.Select-control': {
      display: 'flex',
      alignItems: 'center',
      border: 0,
      height: 'auto',
      background: 'transparent',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    '.Select-multi-value-wrapper': {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
    },
    '.Select--multi .Select-input': {
      margin: 0,
    },
    '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
      padding: 0,
    },
    '.Select-noresults': {
      padding: theme.spacing.unit * 2,
    },
    '.Select-input': {
      display: 'inline-flex !important',
      padding: 0,
      height: 'auto',
    },
    '.Select-input input': {
      background: 'transparent',
      border: 0,
      padding: 0,
      cursor: 'default',
      display: 'inline-block',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      margin: 0,
      outline: 0,
    },
    '.Select-placeholder, .Select--single .Select-value': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(16),
      padding: 0,
    },
    '.Select-placeholder': {
      opacity: 0.42,
      color: theme.palette.common.black,
    },
    '.Select-menu-outer': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      position: 'absolute',
      left: 0,
      top: `calc(100% + ${theme.spacing.unit}px)`,
      width: '100%',
      zIndex: 2,
      maxHeight: ITEM_HEIGHT * 4.5,
    },
    '.Select.is-focused:not(.is-open) > .Select-control': {
      boxShadow: 'none',
    },
    '.Select-menu': {
      maxHeight: ITEM_HEIGHT * 4.5,
      overflowY: 'auto',
    },
    '.Select-menu div': {
      boxSizing: 'content-box',
    },
    '.Select-arrow-zone, .Select-clear-zone': {
      color: theme.palette.action.active,
      cursor: 'pointer',
      height: 21,
      width: 21,
      zIndex: 1,
    },
    // Only for screen readers. We can't use display none.
    '.Select-aria-only': {
      position: 'absolute',
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      height: 1,
      width: 1,
      margin: -1,
    },
    '.clear-icon-wrapper' : {
     
      cursor: "pointer"
    },
    '.clear-icon' : {
      marginTop: 20+"px",
    }
  },
});


class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.initialEntityId != null && this.props.entitys != null && this.props.entitys.length > 0) {
      let initialEntity;
      if (this.props.field.name === "locationId") {
        initialEntity = this.props.entitys.find(l => l.value.locationId === this.props.initialEntityId);
      } else {
        initialEntity = this.props.entitys.find(l => l.value.id === this.props.initialEntityId);
      }
      
      this.state = { entity: initialEntity };
    } else {
      this.state = { entity: null };
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.update && this.props.field.name === "locationId") {
      const entity = this.props.entitys.find(l => l.value.locationId === this.props.values.locationId);
      this.props.resetUpdate();
      this.handleEntityChange(entity);
    }
  }

  handleEntityChange = value => {
    this.setState({
      entity: value
    }, () => {
    });
    const isLocationField =  this.props.field.name === "locationId";
    let val = undefined;
    if(value != null) {
      if(isLocationField) {
        val = value.value.locationId;
      } else {
        val = value.value.id;
      }
    }
    this.props.values[this.props.field.name] = val;
    if (this.props.onChange && value && this.props.field.name === "terminalId") {
      this.props.onChange(value.value.locationId, this.props.entitys);
    }
  };

  render() {
    const { classes, entitys, field } = this.props;

    const inputStyle = { width: 230 + "px" }
    
    // This is to display spinning icon, if the selections are not yet fetched
    if (entitys.length === 0) {
      return (
        <div>
            Loading options... <CircularProgress className={classes.progress} size={20} />
        </div>
      )
    }
    return (
      <div className={this.props.wrapperClass}>
        <Input
          style={{ display: 'none' }}
          value={this.props.values[field.name]}
          id={field.id}
          name={field.name}
        />
        <FormControl>
          <InputLabel shrink={false} htmlFor="entityEdit">{field.label}</InputLabel>
          <div>
          <Input
            inputComponent={SelectWrapped}
            value={this.state.entity}
            style={inputStyle}
            onChange={this.handleEntityChange}
            placeholder={field.label}
            id="entityEdit"
            name="entityEdit"
            inputProps={{
              classes,
              name: 'entityEdit',
              instanceId: 'entityEdit',
              simpleValue: true,
              options: entitys,
            }}
          />
          <span onClick={ () => this.handleEntityChange(null)} className="clear-icon-wrapper"><ClearIcon className="clear-icon"  /></span>
          </div>
        </FormControl>
      </div>
    )
  }
}
export default withStyles(styles)(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/Layout/AutoComplete.js